import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgLegalIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M6 10V4h12v16h-4"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx={9.5}
      cy={15.5}
      r={3.5}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="m8.5 16 1 .5L11 15"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 8h6M13 11h2"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgLegalIcon);
const Memo = memo(ForwardRef);
export default Memo;
